/*-----------------------------------------------------
  Product.swatch.js
  
  - Get products by SKU and display it as related product or custom variant.
-----------------------------------------------------*/
window.theme = window.theme || {}

theme.VariantSKUS = (function() {
  var selectors = {
    products: '.ProductItem',
    container: '.variant-gallery__container',
    label: '.variant-gallery__label span',
    form: 'form.product-form',
  }

  var cache = {};


  function cacheSelectors() {
    cache = {
      $products: $(selectors.products),
      $container: $(selectors.container),
      $form: $(selectors.form),
      $label: $(selectors.label),
      $labelText: $(selectors.label).text(),
    }
  }

  function init() {
    cacheSelectors();
    
    cache.$products.each(function(){
      	let self = $(this),
            SKUMarkup = fetchItemsBySKU(getProductSKU(self));
      
      
      	renderTemplate(self, SKUMarkup);
      
        
    });
    
  }

  
  function renderTemplate(selector, template) {
    selector.find(selectors.container).html('<div class="variant-gallery__carousel">' + template + '</div>');
    
    selector.find('.variant-gallery__carousel').slick({
      dots: false,
      arrows: true,
      infinite: false,
      prevArrow: '<button class="slide-arrow prev-arrow slick-prev"></button>',
      nextArrow: '<button class="slide-arrow next-arrow slick-next"></button>',
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    })
  }

  function createMarkup(product) {
    var productOptical = false, 
    variantType = product.type,
    variantOptical = false,
    sale = false;

    if (product.compare_at_price != null) {
      sale = true;
    }

    
    if (variantOptical === productOptical) {
      var featureImage = imageResize(product.featured_image, '_x500');
      return '<a href="/products/' + product.handle + '" class="variant-gallery__carousel-item" data-product-id="' +  product.id + '" data-product-title="' + product.title + '" data-product-sale="' + sale + '" data-product-optical="' + variantOptical + '"><img src="' + featureImage  + '" alt="' + product.title + '"></a>';
    } else {
      return '';
    }
  }
  
  

  function imageResize(image, size) {
    if (!image) {
      return;
    }
    if (image.includes('.jpeg') || image.includes('.jpg')) {
      var fileType = getFilterCountFileType(image);
      var productImage = image;
      var productImageSplit = productImage.split(fileType, 1);
      var productImageResize = productImageSplit + size + fileType;
      return productImageResize;
    } else {
      return image;
    }
  }
  
  function getFilterCountFileType(image) {
    if (image.includes('.jpeg')) {
      return '.jpeg';
    } else {
      return '.jpg';
    }
  }


  function fetchItemsBySKU(sku) {
    var markup    = '';
    for (var productVar in productVariants) {
      // skip loop if the property is from prototype
      if (!productVariants.hasOwnProperty(productVar)) continue;
      
      if(productVariants[productVar].variants[0].sku !== null ) {

        var currentSku = productVariants[productVar].variants[0].sku.toString().toLowerCase();
        if(currentSku.includes(sku)) {
          console.log(createMarkup(productVariants[productVar]));
          markup = markup + createMarkup(productVariants[productVar]);
        }     
      }
    }
    
    
    return markup;
    /**/
  }

  function getProductSKU(selector) {
    return selector.find('[data-product-sku]').data('product-sku');
  }


  return {
    init: init
  }

})();


theme.VariantSKUS.init();